<template>
	<div class="availability-shortages">
		<button :aria-expanded="expanded"
		        class="availability-shortages__toggle"
		        type="button"
		        @click="expanded = !expanded">

      <div class="week-unavailable-message">
        <svg class="icon-notice" height="16" style="margin-left: 6px;" width="16">
          <use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#notice"></use>
        </svg>
        {{ t('shoppingcart.modal.createpo.content.error.unavailableWeeks.text') }}
      </div>

      <button class="modal-wrapper__select-all" type="button" >
        {{ expanded ? t('shoppingcart.availabilitycheck.shortages.hide.text')
          : t('shoppingcart.availabilitycheck.shortages.show.text') }}
      </button>


		</button>

		<div v-show="expanded" class="availability-shortages__scroll">
			<table class="mydummen-table mydummen-table--order-detail availability-shortages__table">
				<thead>
					<tr>
						<th class="col-variety" scope="col">{{ t('shoppingcart.generic.variety.text') }}</th>
						<th class="col-code" scope="col">{{ t('shoppingcart.generic.code.text') }}</th>
						<th class="col-group" scope="col">{{ t('shoppingcart.generic.group.text') }}</th>
						<th class="col-form" scope="col">{{ t('shoppingcart.generic.form.text') }}</th>
						<th class="col-week" scope="col">{{ t('shoppingcart.generic.week.text') }}</th>
						<th class="col-number" scope="col">
							{{ t('shoppingcart.availabilitycheck.shortages.ordered.label') }}
						</th>
						<th class="col-number" scope="col">
							{{ t('shoppingcart.availabilitycheck.shortages.available.label') }}
						</th>
						<th class="col-number" scope="col">
							{{ t('shoppingcart.availabilitycheck.shortages.short.label') }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="shortage in props.shortages" :key="shortageKey(shortage)">
						<td><strong>{{ shortage.articleName }}</strong></td>
						<td>{{ shortage.articleId }}</td>
						<td>{{ shortage.groupName }}</td>
						<td>{{ shortage.formName }}</td>
						<td>{{ shortage.week }} - {{ shortage.year }}</td>
						<td class="col-number">{{ shortage.amount }}</td>
						<td class="col-number">{{ shortage.amountAvailable }}</td>
						<td class="col-number availability-shortages__short">{{ shortfall(shortage) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import type {AvailabilityShortage} from '@/service/availability.service';
	import {ref, watch} from 'vue';
	import {useI18n} from 'vue-i18n';

	const props = withDefaults(defineProps<{
		shortages: AvailabilityShortage[];
		collapsed?: boolean;
	}>(), {
		collapsed: false
	});

	const {t} = useI18n();

	const expanded = ref(!props.collapsed);

	watch(() => props.collapsed, collapsed => {
		expanded.value = !collapsed;
	});

	const shortageKey = (shortage: AvailabilityShortage): string => {
		return `${shortage.articleId}|${shortage.formId}|${shortage.year}|${shortage.week}`;
	};

	const shortfall = (shortage: AvailabilityShortage): number => {
		return Math.max(0, shortage.amount - shortage.amountAvailable);
	};
</script>

<style lang="scss" scoped>
  @use "sass:math";

	.availability-shortages {
		margin: 1rem 0 0;
		width: 100%;
	}

	.availability-shortages__toggle {
		align-items: baseline;
		background: none;
		border: 0;
		cursor: pointer;
		display: flex;
		gap: .5rem;
		justify-content: space-between;
		padding: 0 0 .5rem;
		text-align: left;
		width: 100%;
	}

	.availability-shortages__title {
		color: #c8102e;
		font-weight: 700;
	}

	.availability-shortages__toggle-label {
		text-decoration: underline;
		text-transform: uppercase;
		font-size: .75rem;
		font-weight: 700;
		letter-spacing: .1425rem;
		white-space: nowrap;
	}

	.availability-shortages__scroll {
		max-height: 18rem;
		overflow-y: auto;
		width: 100%;
	}

	.availability-shortages__table {
		table-layout: fixed;
		width: 100%;
	}

	.availability-shortages__table th,
	.availability-shortages__table td {
		overflow: hidden;
		padding: 6px 8px;
		text-overflow: ellipsis;
	}

	.availability-shortages__table th:first-child,
	.availability-shortages__table td:first-child {
		padding-left: 8px;
	}

	.availability-shortages__table th:last-child,
	.availability-shortages__table td:last-child {
		padding-right: 8px;
	}

	.availability-shortages__table thead th {
		position: sticky;
		top: 0;
		z-index: 1;
	}

	.availability-shortages__table tbody tr {
		border-bottom: 1px solid #ebebeb;
	}

	.availability-shortages__table tbody td {
		padding-bottom: 6px;
	}

	.col-variety { width: 24%; }
	.col-code { width: 10%; }
	.col-group { width: 18%; }
	.col-form { width: 10%; }
	.col-week { width: 12%; }

	.col-number {
		text-align: right;
		white-space: nowrap;
		width: 8.66%;
	}

	.availability-shortages__short {
		color: #c8102e;
		font-weight: 700;
	}

  .week-unavailable-message {
    font-size: math.div(11px, 14px)*1em !important;
    padding: 10px 0 0;
    margin-bottom: 10px;

    .icon-notice {
      margin-right: 6px;
    }
  }
</style>
